import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, ResonateStepData } from '@packages/shared/core/quiz/entities';

type ResonateQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ResonateQuizStep = ({ id, renderQuizScreen }: ResonateQuizStepProps) => {
  const logger = useLogger();

  const { back, next, stepData, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async (withAnswer?: string) => {
    await next(withAnswer, id);
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        totalSteps,
        stepOrder,
        ...(stepData as ResonateStepData),
      })}
    </>
  );
};

export default ResonateQuizStep;
